import type { NDateLocale } from './enUS'
import { faIR } from 'date-fns/locale'

const dateFaIR: NDateLocale = {
  name: 'fa-IR',
  locale: faIR
}

export default dateFaIR
